/* eslint-disable */
import * as Types from '../../../../../../generated/graphql'

import { gql } from '@apollo/client'
export type GQLGiftsFragment = {
  __typename?: 'PublicProfile'
  gifts: {
    __typename?: 'Gifts'
    giftsCount: number
    gifts: {
      __typename?: 'GiftsConnection'
      nodes: Array<{
        __typename?: 'Gift'
        giftId: number
        message: string
        senderHidden: boolean
        my: boolean
        senderProfile?: {
          __typename?: 'PublicProfile'
          id: any
          name: string
          age?: number | null
          gender: Types.GQLGender
          deleted: boolean
          photos: {
            __typename?: 'ProfilePhotos'
            default?: {
              __typename?: 'Photo'
              id: any
              urls: { __typename?: 'PhotoUrls'; square: string }
            } | null
          }
          online?: { __typename?: 'Online'; status: boolean } | null
          relations: {
            __typename?: 'ProfileRelations'
            spaceTimeLocation?: {
              __typename?: 'SpaceTimeLocationRelation'
              text: any
            } | null
          }
          verification: { __typename?: 'Verification'; verifiedPhotos: boolean }
        } | null
        image: {
          __typename?: 'MyGiftImage'
          name: string
          formats: Array<number>
        }
      }>
      pageInfo: {
        __typename?: 'PageInfo'
        endCursor: any
        hasNextPage: boolean
      }
    }
  }
}

export const GiftsFragmentDoc = gql`
  fragment Gifts on PublicProfile {
    gifts {
      giftsCount
      gifts(limit: $giftsLimit, after: null) {
        nodes {
          giftId
          message
          senderHidden
          my
          senderProfile {
            id
            name
            age
            gender
            photos {
              default {
                id
                urls {
                  square
                }
              }
            }
            online {
              status
            }
            relations {
              spaceTimeLocation {
                text
              }
            }
            deleted
            verification {
              verifiedPhotos
            }
          }
          image {
            name
            formats
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
`
